export const onRouteUpdate = ({ location }) => {
  if (location.pathname === "/blog") {
    window.location.href = "https://www.gued.is/garden";
  }
};
